import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { ProductosPorGruposProvider } from '../../providers/productos-por-grupos/productos-por-grupos'
import { PaisesProvider } from '../../providers/paises/paises'
import { SelectSearchable } from 'ionic-select-searchable';
import { ProductosProvider } from '../../providers/productos/productos'

@IonicPage()
@Component({
  selector: 'page-productos-contenedor',
  templateUrl: 'productos-contenedor.html',
})
export class ProductosContenedorPage {
  Ubicacion
  Contenedor
  companiasId
  ubicacionId:string = ""
  contenedorId:string = ""
  public productosId:any
  listaProductos: any = []
  listaProductostodos: any = []
  constructor(public navCtrl: NavController, public navParams: NavParams,
    private storage: Storage,
    public servicio: ProductosPorGruposProvider,
    public alertControllers: AlertController,
    public servicioPaises:PaisesProvider,
    public servicioProductos: ProductosProvider ) {
  }

  ionViewDidLoad() {
    this.cargarValores()
  }

  cargarValores(){
    this.buscarProductos()
    this.cargarServicioUbicacion()
    this.buscarProductosActualizados()
  }

  buscarUbicacion(contenedorId:any){
    
    let id = this.buscarUuidContenedor()
    this.Ubicacion = []
   
        this.servicioPaises.buscarTodoUbicacion('buscarUbicacionPorContenedor',id[0].contenedorId)
        .subscribe((data)=>{
          this.Ubicacion = data
        },(error)=>{
          
          console.log(error)
        })
  }

  buscarUuidContenedor(){
   
  let data = []
  let valorComparar = Number(this.contenedorId)
  for(let k=0;k< this.Contenedor.length;k++){
    if(k === valorComparar){
      
      data.push({
        contenedorId : this.Contenedor[k].contenedorId
      }) 
     this.contenedorId = this.Contenedor[k].contenedorId
    }
  }
  
  return data 
  
}

  cargarServicioUbicacion(){
    this.servicioPaises.buscarTodo('contenedor')
    .subscribe((data) => {
      this.Contenedor = []
      this.Contenedor = data
    }, error => {
      console.log(error)
    })       
  }          
  productosChange(event: { component: SelectSearchable, value: any }) {
    this.productosId = event.value.productosId
  }

  buscarProductos(){  
    this.storage.get('companiasId').then((val) => {
    this.servicioProductos.buscarProductoCompania(val)
    .subscribe((res)=> {
      this.listaProductos = res[0] 
    })
  })
  }

  buscarUuidUbicacion(){
   
    let data = []
    let valorComparar = Number(this.ubicacionId)
    for(let k=0;k< this.Ubicacion.length;k++){
      if(k === valorComparar){
        data.push({
          ubicacionId : this.Ubicacion[k].ubicacionId
        }) 
       this.ubicacionId = this.Ubicacion[k].ubicacionId
      }
    }
    
    return data 
    
  }

  guardar(){
    
    let contenedor =this.buscarUuidContenedor()

    let ubicacionRealId = this.buscarUuidUbicacion() 
    console.log(ubicacionRealId)
    console.log(contenedor)
    let contenedorId = Number(this.contenedorId)
    let ubicacionId = Number(this.ubicacionId)
    let productosId = Number(this.productosId)
    
    // if(contenedorId !== 0  && ubicacionId !== 0 && productosId !== 0){

    
      // let productosContenedor = []
      // productosContenedor['queHago'] = "A"
      // productosContenedor['name'] = "dataDynamicCrud"
      // productosContenedor['nombreTabla'] = "productos"
      // productosContenedor['productosId'] =productosId
      // productosContenedor['contenedorId'] =contenedorId
      // productosContenedor['ubicacionId'] = ubicacionId
     
      // this.servicio.actualizarTodo(productosId,ubicacionId,contenedorId)
      // this.servicio.actualizarTodoafn(productosContenedor)
      
      this.servicio.actualizarTodoafnafn(productosId,ubicacionId,contenedorId)
      .subscribe(
        res => {
          // this.cargarValores()
          this.buscarProductosActualizados()
        },
        err => console.log(err)
      )
    // }else{
    //   this.mostrarMensaje('Existen campos que son requeridos', 'verifique')
    // }
}

buscarProductosActualizados(){
  
  this.storage.get('companiasId').then((val)=>{
    
    this.servicioPaises.buscarUbicacionPorProducto('buscarUbicacionPorProducto',val)
      .subscribe((valores)=>{
          
        let valoresReales = valores
        this.listaProductostodos= []
        this.listaProductostodos = valoresReales
        
      },(error)=>{
        console.log(error)
      })
  })
}

mostrarMensaje(mensaje,title) {
  let alert = this.alertControllers.create({
    title: title,
    subTitle: mensaje,
    buttons: ['Ok']
  });
  alert.present();
}

}



// WEBPACK FOOTER //
// ./src/pages/productos-contenedor/productos-contenedor.ts